import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GenericRepository } from 'src/app/repositories/generic-repository/GenericRepository';
import { ProductionSession, ProductionSessionFilter } from 'src/app/models/Production/ProductionSession';

@Injectable({
  providedIn: 'root'
})
export class ProductionSessionRepository extends GenericRepository<ProductionSession> {
  private readonly apiBase = environment.urlAddress + 'api/productionSession';
  private readonly jsonHeaders = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(protected _http: HttpClient) {
    super(_http, 'api/productionSession', environment.urlAddress);
  }

  SelectAll(filter: ProductionSessionFilter): Observable<any> {
    return this.PostData('/SelectAll', filter as any);
  }

  Select(sessionId: number, batchId: number): Observable<any> {
    return this.Get(`Select/${sessionId}/${batchId}`);
  }

  SelectByBatch(batchId: number, sessionId: number = 0): Observable<any> {
    const sid = sessionId || 0;
    return this._http.get(`${this.apiBase}/SelectByBatch/${batchId}/${sid}`, this.jsonHeaders).pipe(
      map((body: any) => body || {}),
      catchError(() => of({ _statusCode: 404, _obj: null, _message: 'Record not found' }))
    );
  }

  GetBatches(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
    filterText = filterText ? filterText.split('/').join('~') : '';
    return this.Get(`Batches/${currentPage}/${recordsPerPage}/${filterText || ''}`);
  }

  GetQCInspections(sessionId: number): Observable<any> {
    return this._http.get(`${this.apiBase}/QCInspections/${sessionId}`, this.jsonHeaders).pipe(
      map((body: any) => body || {}),
      catchError(() => of({ _statusCode: 200, _obj: [] }))
    );
  }
}
